

import React, { Component } from 'react';
import lodashGet from 'lodash/get';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

const clsPrefix = 'pdf-annotate-text-strikeout';

@observer
export default class PdfStrikeoutText extends Component {
  static propTypes = {
    annotations: PropTypes.object.isRequired,
    annotation: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.divElement = React.createRef();
  }

  handlePointerDown = (event) => {
    event.stopPropagation();
    const { annotations, annotation } = this.props;
    const name = lodashGet(annotation, 'customData.name');
    if (name) {
      annotations.selectByName(name);
      return;
    }
    setTimeout(() => {
      annotations.setSelectedAnnotations([annotation]);
    }, 0);
  };

  render() {
    const { annotations, annotation } = this.props;
    const { pspdfkitInstance, selectedAnnotations } = annotations;

    const selected =
      pspdfkitInstance &&
      (selectedAnnotations || []).find(({ id }) => id === annotation.id);

    let height = 1;
    if (this.divElement && this.divElement.current) {
      height = Math.max(
        1,
        (4 / 100) * this.divElement.current.getBoundingClientRect().height
      );
    }

    return (
      <div className={clsPrefix} onPointerDownCapture={this.handlePointerDown}>
        <div
          ref={this.divElement}
          className={`${clsPrefix}__select-border`}
          style={{
            display: selected ? 'block' : 'none',
          }}
        />
        <div
          className={`${clsPrefix}__strikeout`}
          style={{ height: `${height}px` }}
        />
      </div>
    );
  }
}
